<template>
  <div>
    <h1 class="title">Product List Management</h1>
    <div class="discount">
      <div class="box has-background-light">
        <div class="field">
          <div class="file is-primary" :class="{ 'has-name': file.name }">
            <label class="file-label">
              <input class="file-input" accept=".csv" type="file" ref="file" name="discountList" v-on:change="handleFileUpload">
              <span class="file-cta">
                <span class="file-label">
                  Add the product list
                </span>
              </span>
              <span class="file-name" v-if="file.name">
                {{file.name}}
              </span>
            </label>
          </div>
          <p class="help">Please note only <code>.csv</code> files are accepted.</p>
        </div>
        <div class="field">
          <button class="button" :disabled="loading" :class="{ 'is-loading': loading }" v-on:click="submitFile()">Upload</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import errorHandler from '@/errorHandler';

export default {
  data() {
    return {
      file: '',
      fileID: '',
      loading: false,
    };
  },

  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    submitFile() {
      const formData = new FormData();
      formData.append('file', this.file);

      if (this.loading === false) {
        this.loading = true;

        fetch('/api/product', {
          method: 'POST',
          body: formData,
        }).then(res => res.json())
          .catch(error => errorHandler(error))
          .then((response) => {
            this.fileID = response.fields.fileID;
            this.loading = false;
            this.$awn.success('Product list uploaded');
          });
      }
    },
  },
};
</script>
